// Exports report data to an Excel file
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
// import styles from '../css/exportToExcel.module.css';

export const exportToExcel = (
  reportData,
) => {
  // Create a new workbook and worksheet
  const workbook =
    XLSX.utils.book_new();
  const worksheet =
    XLSX.utils.json_to_sheet(
      reportData,
    );
  XLSX.utils.book_append_sheet(
    workbook,
    worksheet,
    'ReportData',
  );
  // Generate buffer
  const excelBuffer = XLSX.write(
    workbook,
    {
      bookType: 'xlsx',
      type: 'array',
    },
  );
  // Create a Blob from the buffer
  const data = new Blob([excelBuffer], {
    // type: 'application/octet-stream',
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
  });
  // Save the file using file-saver
  saveAs(data, 'ReportData.xlsx');
};
